/**
 * @fileoverview 開催枠（EventOffer）の表示に関するロジック
 */

import { DATETIME_FORMAT_JA } from '@/constants/dateFormat'
import { localeDateJa } from '@/utilities/formatter'

/**
 * 開催枠（EventOffer）の開催日時ラベル「開始日時-表示文言」を返す（#8916）
 * @description 終了時刻は表示しない。表示文言は入力値をそのまま連結する（未設定なら「開始日時-」で終わる）
 * @param from 開催枠の開始日時
 * @param displayLabel 開催枠の表示文言（会場名など）
 */
export function formatEventOfferLabel(from: string, displayLabel?: string | null): string {
  return `${localeDateJa(from, DATETIME_FORMAT_JA)}-${displayLabel ?? ''}`
}
